import { _converse, api } from '@converse/headless';
import { html } from 'lit';
import { CustomElement } from './element.js';
import { __ } from 'i18n';

export class ConverseFooter extends CustomElement {
    render() {
        const is_fullscreen = api.settings.get('view_mode') === 'fullscreen';
        const theme = api.settings.get('theme');
        const is_dark_theme = ['dracula', 'cyberpunk'].includes(theme);
        const i18n_sponsors = __('A big thank you to our sponsors 🙏');
        return html`${is_fullscreen
                ? html`<footer class="footer mt-auto py-3 pb-3"><div class="container"><div class="row"><div class="col-12 text-center"><p class="brand-subtitle mb-2 subdued">نسخه: ${_converse.VERSION_NAME}</p><p class="brand-subtitle mb-4">پیام‌رسان نور - سرویس گفتگوی امن و خصوصی</p><div class="sponsors text-center" style="display:none"><p class="byline mb-1">${i18n_sponsors}</p><p class="brand-subtitle mb-3">پیام‌رسان نور - سرویس گفتگوی امن و خصوصی</p></div></div></div></div></footer>`
                : ''}`;
    }
}

api.elements.define('converse-footer', ConverseFooter);
